export const ROUTE_LABELS: Record<string, string> = {
  '/': 'Dashboard',
  '/signin': 'Login',
  '/users': 'Usuários',
  '/anpr-events': 'Eventos de Veículos',
  '/ahcr-events': 'Eventos de Pessoas',
  '/alarms': 'Alarmes',
  '/cameras': 'Câmeras',
  '/stream': 'Câmeras Live',
  '/map': 'Mapa de Câmeras',
  '/health': 'Saúde do Sistema',
  '/settings': 'Configurações',
}

export const APP_NAME = 'RT Guard'